const axios = require('axios')


const REST_DOMAIN = 'https://maddik.org:9881'
//const REST_DOMAIN = 'http://localhost:9881'

function getBearer() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user'))

    if (user && user.token) {
        return 'Bearer ' + user.token
    } else {
        return ''
    }
}


function request(urlPath, method, body) {
    const options = {
        headers: { Authorization: getBearer() },
        responseEncoding: 'utf8',
        responseType: 'json',
        url: REST_DOMAIN + urlPath,
        method,
        data: body === true || !body ? {} : body
    }

    return axios(options)
        .then(response => {
            const result = response.data

            return result
        })

}

export const rest = {
    getBearer,
    REST_DOMAIN,
    request,
}